import { render, staticRenderFns } from "./PreCardView.vue?vue&type=template&id=6f38c00a&"
import script from "./PreCardView.vue?vue&type=script&lang=js&"
export * from "./PreCardView.vue?vue&type=script&lang=js&"
import style0 from "./PreCardView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports